module.exports = __webpack_public_path__ + "img/earth.edcff288.png";